var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6329 11.2816L11.675 9.32371C10.9758 8.62447 9.7871 8.90419 9.50741 9.81317C9.29764 10.4425 8.5984 10.7921 7.96909 10.6523C6.57063 10.3026 4.6827 8.48463 4.33308 7.01624C4.12331 6.3869 4.54285 5.68767 5.17216 5.47792C6.08116 5.19823 6.36086 4.00954 5.66162 3.3103L3.70377 1.35245C3.14439 0.862986 2.30531 0.862986 1.81584 1.35245L0.4873 2.68099C-0.841242 4.07946 0.627147 7.78539 3.91354 11.0718C7.19994 14.3582 10.9059 15.8965 12.3043 14.498L13.6329 13.1695C14.1224 12.6101 14.1224 11.771 13.6329 11.2816Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.84d8509bc08283637a2c531b17d76191.svg";
export { ForwardRef as ReactComponent };